export default "__VITE_ASSET__DQWxGwlr__"